<template>
  <v-container fluid>
    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>I Consume</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="formattedData"
          class="elevation-1 mt-4"
        >
          <template v-slot:item.dataEntry="{ item }">
            <v-row no-gutters>
              <v-col>
                <v-btn
                  :disabled="
                    item.hasData === true ||
                    item.status === 'rejected' ||
                    item.status === 'pending'
                  "
                  class="mr-2 white--text custom-button"
                  small
                  color="pink"
                  @click="goToDataPage(item)"
                  >Add Data</v-btn
                >
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import RestResource from "../../../services/dataServiceMobileV2";
import moment from "moment";
const service = new RestResource();

export default {
  data() {
    return {
      beverages: [],
      headers: [
        { text: "Email", value: "email" },
        { text: "User ID", value: "userId" },
        { text: "Submission Id", value: "_id" },
        { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "dataEntry" },
      ],
    };
  },

  computed: {
    formattedData() {
      return this.beverages.map((data) => ({
        ...data,
        createdAt: data.createdAt
          ? moment(data.createdAt).format("DD-MMM-YYYY")
          : "Not Found",
      }));
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      this.$setLoader();
      service.getBeverageData().then((r) => {
        this.beverages = r.data.data;
        this.$disableLoader();
      });
    },
    goToDataPage(item) {
      const url = this.$router.resolve({
        name: "MobileV2AddIConsume",
        params: { userId: item.userId, submissionId: item._id },
      }).href;

      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.v-img.clickable {
  cursor: pointer;
}
</style>
